export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NewsListingItem.vue?vue&type=template&id=318d4f20&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/NewsListingItem.vue?vue&type=template&id=318d4f20&scoped=true&
// module id = 355
// module chunks = 0